import { createSelector } from 'reselect'

import { selectJBPSettings } from './selectJBPSettings'

export const selectJBPSettingsSobActualRequiredQuarters = createSelector(
  [selectJBPSettings],
  ({ sobActualRequiredQuarters }) => sobActualRequiredQuarters
)
